import React, { useState } from 'react';
import { personalInfo } from '../data.js';
import { HiMenu, HiX } from 'react-icons/hi';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navItems = [
    'about',
    'education',
    'experience',
    'publications',
    'projects',
    'skills',
    'awards',
    'miscellaneous',
  ];

  return (
    <header className="fixed top-0 left-0 w-full bg-gray-900 text-white shadow-md z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-3">
        {/* Logo */}
        <div className="flex-shrink-0">
          <a href="#about">
            <img
              src={personalInfo.logo}
              alt="Logo"
              className="h-16 w-auto object-contain"
            />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex flex-1 justify-center space-x-6">
          {navItems.map((item) => (
            <a
              key={item}
              href={`#${item}`}
              className="hover:text-blue-400 transition-colors capitalize"
            >
              {item}
            </a>
          ))}
        </nav>

        {/* Mobile Hamburger Icon */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="focus:outline-none"
            aria-label="Toggle Menu"
          >
            {menuOpen ? <HiX className="w-8 h-8" /> : <HiMenu className="w-8 h-8" />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-gray-800 px-6 py-4 space-y-4">
          {navItems.map((item) => (
            <a
              key={item}
              href={`#${item}`}
              className="block text-white hover:text-blue-400 transition-colors capitalize"
              onClick={() => setMenuOpen(false)} // Close menu when clicking link
            >
              {item}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
